import { render, staticRenderFns } from "./MyObject.vue?vue&type=template&id=a17e1fd6&scoped=true&"
import script from "./MyObject.vue?vue&type=script&lang=js&"
export * from "./MyObject.vue?vue&type=script&lang=js&"
import style0 from "./MyObject.vue?vue&type=style&index=0&id=a17e1fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17e1fd6",
  null
  
)

export default component.exports